// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"180":"a550321a604296bf","405":"4bda85f0d8d10876","473":"4bda85f0d8d10876","888":"b1d1143426596fed"}[chunkId] + ".css";
};